export default __webpack_public_path__ + "media/projects/yellow1-d5b27950.svg";